import { getDataLinkAttributes } from "@/helpers";
import { FC } from "react";
import { Card, Media } from "@/types/General";
import Link from "@/components/Link";
import Image from "next/image";
import { imageLoader } from "@/helpers";

type UseCaseCardProps = {
  type?: string;
  media?: Media;
} & Extract<Card, { type: "Use Case" } | { type: "Solution" }>;

export const UseCaseCard: FC<UseCaseCardProps> = (props) => {
  return (
    <Link
      data-automation-group="card"
      className="hover:shadow-card border-symbol-silver-300-graphic bg-background-highlight group focus-visible:outline-swdc-blue-400 inline-block border outline-2 outline-offset-0 outline-transparent"
      href={props.link?.url || "#"}
      {...getDataLinkAttributes(props.link)}
    >
      {props.media?.type === "image" && (
        <Image
          src={props.media.image}
          alt={`${props.title} Card Image`}
          width={782}
          height={440}
          loader={imageLoader({
            ...props.media,
            width: 782,
            height: 440,
            alt: `${props.title} Card Image`,
          })}
          className="aspect-8/5"
        />
      )}
      <div className="px-4 py-6">
        <div
          role="heading"
          aria-level={4}
          aria-label={`${props.type}: ${props.title}`}
          className="text-subhead-2xs sm:text-subhead-xs text-tab-link group-active:text-tab-link-pressed leading-7 font-bold group-hover:underline group-focus-visible:underline"
        >
          {props.title}
        </div>
        <div
          className="text-body-s text-body-primary mt-4"
          dangerouslySetInnerHTML={{ __html: props.description }}
        />
      </div>
    </Link>
  );
};
